import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';

import AuthorizeInfo from './authorize-info.vue';
import AuthorizeSubscribe from './authorize-subscribe.vue';
import AuthorizePackage from './authorize-package.vue';
import AuthorizeStopCharging from './authorize-stop-charging.vue';
import AuthorizeRevenue from '../components/authorize-revenue.vue';
import { GrantType, AdvertiserAccountType, PermissionKey, PlanType, PlanScope, PlanNormal } from '@/common/permission';
import _ from 'lodash';
import { createGrant, getGrantRevenue, updateGrant, fetchGrantList } from '@/api/grant/grant';
import { getTotalAmount } from '../utils';
import { format } from 'date-fns';
import { ChangeKeys } from './config';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },

    subscribeTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    action: {
      type: String,
      default: 'create'
    },

    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    demoMaxPushCount: {
      type: Number,
      default: 0
    }
  },

  components: {
    AuthorizeSubscribe: AuthorizeSubscribe,
    AuthorizeInfo: AuthorizeInfo,
    AuthorizeRevenue: AuthorizeRevenue,
    AuthorizePackage: AuthorizePackage,
    AuthorizeStopCharging: AuthorizeStopCharging
  },

  data: function data() {
    return {
      loading: false,
      formValue: {
        adv_id: '',
        grant_type: GrantType.Normal,
        plan_id: '',
        permissions: '',
        expired_date: '',
        template_ids: [],
        channel_ids: [],
        is_all_template: true,
        is_all_channel: true,
        days: '',
        invoice_id: '',
        reset_day: '',
        render_video: '',
        download_push: '',
        voice_clone: '',
        video_credits: 0, // 点数
        mtg_charge: '',
        online: '',
        revenue: 0, // 授权金额
        isEdit: false, // 是否可编辑
        disabledChannel: false, // 渠道禁用
        mws_account_type: AdvertiserAccountType.Normal,
        disabledTrial: false,
        type: PlanType.Subscription,
        change_keys: [],
        plan_scope: PlanScope.Playable, // 应用权限
        is_all_download_push: true, // 可玩下载推送数
        is_all_render_video: true, // 视频导出数
        is_all_support_credit: true, // 默认账户余额
        is_set_price_ceiling: true, // 计费套餐设置价格上限

        // 信用支付
        credit: {
          min_amount: 0,
          support_credit: 1,
          approval_url: ''
        },
        checkPermissions: [PermissionKey.ai],
        aigc_credits: 0,
        unit_price: 0,
        max_service_fee: -1,
        storage: '',
        image: '',

        // 停止计费策略
        stop_bill_method: '',
        channel_buyout_price: 800,
        creative_buyout_price: 801,
        channel_max_price: 800,
        creative_max_price: 801,
        bill_method_image: '',
        approval_url: ''
      },
      grantInfo: {},
      PlanNormal: PlanNormal,
      updateInfo: {
        channel_price: 0,
        creative_price: 0
      }
    };
  },


  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },

    dialogAttrs: function dialogAttrs() {
      return _extends({
        title: this.action === 'update' ? '修改授权' : '新增授权'
      }, this.$attrs);
    },
    rules: function rules() {
      var _this = this;

      var validateInit = function validateInit(rule, value, callback) {
        var reg = /(^[1-9]\d*$)/;
        if (reg.test(value) || value === 0) {
          callback();
        } else {
          callback(new Error('请输入正整数'));
        }
      };

      var validateBillMethodImage = function validateBillMethodImage() {
        if (_this.formValue.type === PlanType.Recharge && _this.action !== 'create') {
          if (_this.formValue.stop_bill_method === 'buyout') {
            return !(_this.formValue.channel_buyout_price === _this.updateInfo.channel_price && _this.formValue.creative_buyout_price === _this.updateInfo.creative_price);
          } else if (_this.formValue.stop_bill_method === 'cap') {
            return !(_this.formValue.channel_max_price === _this.updateInfo.channel_price && _this.formValue.creative_max_price === _this.updateInfo.creative_price);
          }
          return false;
        }
        return false;
      };

      var creativeMaxPriceValidate = function creativeMaxPriceValidate(rule, value, callback) {
        if (value > _this.formValue.channel_max_price) {
          callback();
        } else {
          callback(new Error('全渠道cap需大于渠道cap'));
        }
      };

      var creativeBuyoutPriceValidate = function creativeBuyoutPriceValidate(rule, value, callback) {
        if (value > _this.formValue.channel_buyout_price) {
          callback();
        } else {
          callback(new Error('全渠道buyout需大于渠道buyout'));
        }
      };

      var validatePlayable = function validatePlayable(rule, value, callback) {
        if ([PermissionKey.gm, PermissionKey.ps].some(function (item) {
          return _this.formValue.checkPermissions.includes(item);
        })) {
          callback();
        } else {
          callback(new Error('至少勾选一个可玩功能权限'));
        }
      };

      var validateVideo = function validateVideo(rule, value, callback) {
        if ([PermissionKey.vrec, PermissionKey.aigc, PermissionKey.veTpl, PermissionKey.ve + ',' + PermissionKey.veBatch].some(function (item) {
          return _this.formValue.checkPermissions.includes(item);
        })) {
          callback();
        } else {
          callback(new Error('至少勾选一个视频功能权限'));
        }
      };
      return {
        adv_id: [{ required: true, trigger: 'change', message: '请选择广告主' }],
        template_ids: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (_this.formValue.is_all_template) {
              callback();
            } else if (value.length === 0) {
              callback(new Error('请选择模板'));
            } else {
              callback();
            }
          }
        }],
        channel_ids: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (_this.formValue.is_all_channel) {
              callback();
            } else if (value.length === 0) {
              callback(new Error('请选择渠道'));
            } else {
              callback();
            }
          }
        }],
        grant_type: [{ required: true, trigger: 'change', message: '请选择订阅类型' }],
        plan_id: [{ required: true, trigger: 'change', message: '请选择套餐' }],
        days: [{
          required: true,
          trigger: 'change',
          message: '请选择订阅天数'
        }],
        invoice_id: [{
          required: true,
          trigger: 'change',
          message: '请选择invoice信息'
        }],
        playable: [{
          required: true,
          trigger: 'change',
          validator: validatePlayable
        }],
        video: [{
          required: true,
          trigger: 'change',
          validator: validateVideo
        }],
        revenue: [{
          required: true,
          trigger: 'change',
          validator: validateInit
        }],
        channel_buyout_price: [{ required: true, trigger: 'change', message: '不能为空' }],
        creative_buyout_price: [{
          required: true,
          trigger: 'change',
          validator: creativeBuyoutPriceValidate
        }],
        channel_max_price: [{ required: true, trigger: 'change', message: '不能为空' }],
        stop_bill_method: [{ required: true, trigger: 'change', message: '请选择停止计费方式' }],
        creative_max_price: [{
          required: true,
          trigger: 'change',
          validator: creativeMaxPriceValidate
        }],
        image: this.formValue.type === PlanType.Recharge && !this.formValue.is_all_support_credit ? [{
          required: true,
          trigger: 'blur',
          message: '请上传特批邮件截图'
        }] : { required: false },
        bill_method_image: validateBillMethodImage() ? [{
          required: true,
          trigger: 'blur',
          message: '请上传特批邮件截图'
        }] : { required: false }
      };
    },
    canFetchRevenue: function canFetchRevenue() {
      // 根据服务端计算的逻辑，涉及到计算影响的字段：
      // ExpiredDate、AccountType、SubscribeType、ExtraOnlineLimit、ExtraDownloads
      var _formValue = this.formValue,
          adv_id = _formValue.adv_id,
          days = _formValue.days,
          plan_id = _formValue.plan_id;

      return [adv_id, days, plan_id].join('-');
    },


    // 企业套餐下显示
    showAbility: function showAbility() {
      return this.formValue.plan_id === PlanNormal.planEnterprise;
    },

    // 充值消耗套餐下的信用配置面板
    showPayment: function showPayment() {
      return [PlanType.Recharge].includes(this.formValue.type);
    },

    // 付费金额
    showRevenue: function showRevenue() {
      return this.action === 'create' && !this.showPayment;
    }
  },

  watch: {
    dialogVisible: function dialogVisible(val) {
      if (this.$refs.form && this.action === 'create') {
        var form = this.$refs.form;

        form.resetFields();
        form.clearValidate();
      }
      if (val) {
        this.init(this.authorizeInfo);
      } else {
        this.grantInfo = {};
        this.formValue.disabledTrial = false;
        this.formValue.plan_id = '';
        this.formValue.permissions = '';
        this.formValue.template_ids = [];
        this.formValue.channel_ids = [];
        this.formValue.reset_day = '';
        this.formValue.render_video = '';
        this.formValue.mtg_charge = '';
        this.formValue.download_push = '';
        this.formValue.voice_clone = '';
        this.formValue.video_credits = 0;
        this.formValue.isEdit = false;
        this.formValue.days = '';
        this.formValue.revenue = '';
        this.formValue.online = '';
        this.formValue.change_keys = [];
        this.formValue.checkPermissions = [PermissionKey.ai];
        this.formValue.aigc_credits = 0;
        this.formValue.storage = '';
        this.formValue.stop_bill_method = '';
        this.formValue.channel_buyout_price = 800;
        this.formValue.creative_buyout_price = 801;
        this.formValue.channel_max_price = 800;
        this.formValue.creative_max_price = 801;
        this.formValue.bill_method_image = '';
        this.formValue.approval_url = '';
      }
    },


    // authorizeInfo: {
    //   handler(val) {
    //     this.init(val)
    //   },
    //   deep: true,
    // },

    canFetchRevenue: function canFetchRevenue() {
      var _this2 = this;

      // if (this.formValue.account_type === 'normal') {
      // 充值A餐、充值B餐金额固定，不可调整
      if (this.formValue.isEdit) return;

      var params = this.getParams();

      if (params.days === '') return;

      getGrantRevenue({
        plan_id: params.plan_id,
        days: params.days
      }, true /* 开启错误时候不展示错误消息 */
      ).then(function (res) {
        _this2.formValue.revenue = res.data.data.revenue;
      });
      // }
    },
    'formValue.grant_type': function formValueGrant_type() {
      this.checkDisabledTrial();

      if (this.action === 'create') {
        this.formValue.plan_id = '';
        this.formValue.permissions = '';
      }
    },
    'formValue.adv_id': function formValueAdv_id() {
      this.getAdvPrimaryPlanInfo();
      this.checkDisabledTrial();
    },
    'formValue.plan_scope': function formValuePlan_scope() {
      this.$refs.form.clearValidate();
    }
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('update:visible', false);
    },
    handleSaveSuccess: function handleSaveSuccess() {
      this.closeDialog();
      this.$emit('save-success');
    },
    checkDisabledTrial: function checkDisabledTrial() {
      // 授权范围是视频+可玩, 不能加其他试用
      if (this.action === 'update' || this.formValue.grant_type !== GrantType.Trial || !this.grantInfo.permissions) {
        this.formValue.disabledTrial = false;

        return;
      }

      var permissions = this.grantInfo.permissions.split(',');

      this.formValue.disabledTrial = permissions.includes(PermissionKey.gm) && permissions.includes(PermissionKey.ps) && permissions.includes(PermissionKey.ve) && permissions.includes(PermissionKey.vrec);
    },
    init: function init(authorizeInfo) {
      if (_.isEmpty(authorizeInfo)) return;

      this.grantInfo = _extends({}, authorizeInfo);

      this.formValue.plan_id = authorizeInfo.plan_id;
      this.formValue.grant_type = authorizeInfo.grant_type;
      this.formValue.reset_day = authorizeInfo.reset_day;
      this.formValue.mtg_charge = authorizeInfo.mtg_charge;
      this.formValue.type = authorizeInfo.plan_type;

      this.formValue.render_video = getTotalAmount(authorizeInfo, 'render_video');
      this.formValue.download_push = getTotalAmount(authorizeInfo, 'download_push');

      this.formValue.aigc_credits = getTotalAmount(authorizeInfo, 'aigc_credits');

      this.formValue.voice_clone = getTotalAmount(authorizeInfo, 'voice_clone');

      // 点数
      this.formValue.video_credits = getTotalAmount(authorizeInfo, 'video_credits');

      this.formValue.online = getTotalAmount(authorizeInfo, 'online');

      this.formValue.storage = getTotalAmount(authorizeInfo, 'storage');

      if (authorizeInfo.permissions) {
        this.formValue.permissions = authorizeInfo.permissions;
      }
      if (authorizeInfo.template_ids) {
        this.formValue.template_ids = authorizeInfo.template_ids.split(',').filter(function (item) {
          return Boolean(item);
        });
      }
      if (authorizeInfo.channel_ids) {
        this.formValue.channel_ids = authorizeInfo.channel_ids.split(',').filter(function (item) {
          return Boolean(item);
        });
      }

      if (this.formValue.template_ids.length) {
        this.formValue.is_all_template = false;

        this.formValue.template_ids = (this.formValue.template_ids || []).map(function (item) {
          return Number(item);
        });
      } else {
        this.formValue.is_all_template = true;
      }

      if (this.formValue.channel_ids.length) {
        this.formValue.is_all_channel = false;
        this.formValue.channel_ids = (this.formValue.channel_ids || []).map(function (item) {
          return Number(item);
        });
      } else {
        this.formValue.is_all_channel = true;
      }

      // 企业套餐下的数据回显
      if (authorizeInfo.plan_id === PlanNormal.planEnterprise) {
        this.formValue.plan_scope = authorizeInfo.plan_scope;
        if (authorizeInfo.permissions.includes(PermissionKey.ve + ',' + PermissionKey.veBatch)) {
          var vePermission = PermissionKey.ve + ',' + PermissionKey.veBatch;
          this.formValue.checkPermissions = [].concat(_toConsumableArray(authorizeInfo.permissions.replace(vePermission, '').split(',')), [vePermission]);
        } else {
          this.formValue.checkPermissions = authorizeInfo.permissions.split(',');
        }

        this.formValue.mtg_charge = String(authorizeInfo.mtg_charge);
      }

      // 充值套餐下的数据回显
      if (authorizeInfo.plan_type === PlanType.Recharge) {
        this.formValue.image = authorizeInfo.approval_url || '';
        this.formValue.credit.min_amount = authorizeInfo.credit_amount || 0;
        if (this.formValue.credit.min_amount) {
          this.formValue.is_all_support_credit = false;
        }
        this.formValue.bill_method_image = authorizeInfo.approval_url || '';
        this.formValue.stop_bill_method = authorizeInfo.stop_bill_method || '';
        this.formValue.channel_buyout_price = authorizeInfo.channel_buyout_price || '';
        this.formValue.creative_buyout_price = authorizeInfo.creative_buyout_price || '';
        this.formValue.channel_max_price = authorizeInfo.channel_max_price || '';
        this.formValue.creative_max_price = authorizeInfo.creative_max_price || '';
        this.formValue.approval_url = authorizeInfo.approval_url ? new URL(authorizeInfo.approval_url).pathname.slice(1) : '';
        this.updateInfo.channel_price = authorizeInfo.stop_bill_method === 'buyout' ? authorizeInfo.channel_buyout_price : authorizeInfo.channel_max_price;
        this.updateInfo.creative_price = authorizeInfo.stop_bill_method === 'buyout' ? authorizeInfo.creative_buyout_price : authorizeInfo.creative_max_price;
      }

      // this.getAdvertiserList(
      //   authorizeInfo.adv_id
      //     ? { keyword: authorizeInfo.adv_id, search_field: 'id' }
      //     : {},
      // )
    },
    getParams: function getParams() {
      var params = _.pick(this.formValue, ['adv_id', 'channel_ids', 'days', 'invoice_id', 'plan_id', 'revenue', 'template_ids']);

      // pl套餐赋值
      if (this.formValue.plan_scope === PlanScope.Playable || this.formValue.plan_scope === PlanScope.Playable_Video) {
        // 指定模板赋值
        if (this.formValue.is_all_template) {
          params.template_ids = '-1';
        } else {
          params.template_ids = this.formValue.template_ids.join(',');
        }

        // 指定渠道赋值
        if (this.formValue.is_all_channel) {
          params.channel_ids = '-1';
        } else {
          params.channel_ids = this.formValue.channel_ids.join(',');
        }
      } else {
        // 非可玩套餐不需要可玩配置字段
        delete params.template_ids;
        delete params.channel_ids;
      }

      // 企业套餐下增加的参数
      if (this.showAbility) {
        params.permissions = this.formValue.checkPermissions.join(',');
        params.plan_scope = this.formValue.plan_scope;
        params.mtg_charge = Number(this.formValue.mtg_charge);
        params.reset_day = this.formValue.reset_day;
      }

      // 指定充值A餐、充值B餐可玩额度、在线人数
      if (this.formValue.change_keys.length > 0) {
        params.ext_value = {};
      }
      if (this.formValue.change_keys.includes(ChangeKeys.Online)) {
        params.ext_value.online = this.formValue.online;
      }
      if (this.formValue.change_keys.includes(ChangeKeys.VoiceClone)) {
        params.ext_value.voice_clone = this.formValue.voice_clone;
      }
      if (this.formValue.change_keys.includes(ChangeKeys.VideoCredits)) {
        if (this.showAbility && this.formValue.checkPermissions.includes(PermissionKey.ve + ',' + PermissionKey.veBatch)) {
          params.ext_value.video_credits = this.formValue.is_all_render_video ? -1 : this.formValue.video_credits;
        } else {
          params.ext_value.video_credits = this.formValue.video_credits;
        }
      }

      if (this.formValue.change_keys.includes(ChangeKeys.DownloadPush)) {
        if (this.showAbility && (this.formValue.plan_scope === PlanScope.Playable || this.formValue.plan_scope === PlanScope.Playable_Video)) {
          params.ext_value.download_push = this.formValue.is_all_download_push ? -1 : this.formValue.download_push;
        } else {
          params.ext_value.download_push = this.formValue.download_push;
        }
      }

      if (this.formValue.change_keys.includes(ChangeKeys.AigcCredits)) {
        params.ext_value.aigc_credits = this.formValue.aigc_credits;
      }
      if (this.formValue.change_keys.includes(ChangeKeys.Storage)) {
        params.ext_value.storage = this.formValue.storage;
      }
      // 充值消耗套餐
      if (this.showPayment) {
        params.credit = {};
        params.unit_price = this.formValue.unit_price;
        params.credit.support_credit = this.formValue.credit.support_credit;
        params.credit.min_amount = this.formValue.is_all_support_credit ? 0 : this.formValue.credit.min_amount;
        if (!this.formValue.is_all_support_credit) {
          params.credit.approval_url = this.formValue.credit.approval_url;
        }

        params.max_service_fee = this.formValue.is_set_price_ceiling ? this.formValue.max_service_fee : -1;

        // 停止计费策略
        params.stop_bill_method = this.formValue.stop_bill_method;
        if (this.formValue.stop_bill_method === 'buyout') {
          params.channel_buyout_price = this.formValue.channel_buyout_price;
          params.creative_buyout_price = this.formValue.creative_buyout_price;
        } else {
          params.channel_max_price = this.formValue.channel_max_price;
          params.creative_max_price = this.formValue.creative_max_price;
        }
        if (this.action === 'update') {
          params.approval_url = this.formValue.approval_url;
        }
      }
      return params;
    },
    submit: function submit() {
      var _this3 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          var params = _this3.getParams();

          if (_this3.action === 'update') {
            params.id = _this3.authorizeInfo.id;
          }

          _this3.loading = true;
          var fn = _this3.action === 'create' ? createGrant : updateGrant;
          fn(params).then(function (res) {
            _this3.handleSaveSuccess();
          }).finally(function () {
            _this3.loading = false;
          });
        }
      });
    },
    getAdvPrimaryPlanInfo: function getAdvPrimaryPlanInfo() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this4.formValue.adv_id !== '')) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return fetchGrantList({
                  grant_types: GrantType.Normal,
                  adv_ids: _this4.formValue.adv_id
                });

              case 3:
                res = _context.sent;
                list = _.get(res, 'data.data.list') || [];


                if (list.length > 0 && list[0].status === 'active') {
                  _this4.grantInfo = list[0];
                  _this4.grantInfo.expired_time = _this4.grantInfo.expired_time ? format(_this4.grantInfo.expired_time * 1000, 'YYYY-MM-DD HH:mm:ss') : '-';
                } else {
                  _this4.grantInfo = {};
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    }
  }
};